/**
 * Motion preferences. Reduced motion keeps every animation (the scene still never jumps in logic)
 * but runs timelines ~10x faster and drops particles, so the screen settles almost instantly.
 */
let override: boolean | null = null;

export function prefersReducedMotion(): boolean {
  if (override !== null) return override;
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false;
  try {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch {
    return false;
  }
}

/** Tests and a settings toggle can force the preference. */
export function setReducedMotion(value: boolean | null): void {
  override = value;
}

/** Speed multiplier applied to every timeline. */
export function motionTimeScale(): number {
  return prefersReducedMotion() ? 10 : 1;
}
